module.exports = __webpack_public_path__ + "assets/details-north-america.5fcb2162.svg";